import { darken } from 'polished';
export const generateSnackbarCommonStyles = (color) => ({
    cursor: 'pointer',
    fontWeight: 500,
    '&:hover': {
        backgroundColor: darken(0.2, color),
    },
});
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXRpbHMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvdGhlbWUvdXRpbHMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxFQUFFLE1BQU0sRUFBRSxNQUFNLFVBQVUsQ0FBQztBQUVsQyxNQUFNLENBQUMsTUFBTSw0QkFBNEIsR0FBRyxDQUFDLEtBQWEsRUFBRSxFQUFFLENBQUMsQ0FBQztJQUM5RCxNQUFNLEVBQUUsU0FBUztJQUNqQixVQUFVLEVBQUUsR0FBRztJQUNmLFNBQVMsRUFBRTtRQUNULGVBQWUsRUFBRSxNQUFNLENBQUMsR0FBRyxFQUFFLEtBQUssQ0FBQztLQUNwQztDQUNGLENBQUMsQ0FBQyJ9